import React from "react"

import { FeedbackType } from "shared/types/FeedbackType"

import { FeedbackActionsOverlayView } from "./FeedbackActionsOverlayView"
import { useFeedbackActionsOverlayViewModel } from "./hooks/useFeedbackActionsOverlayViewModel"

export interface FeedbackActionsOverlayModel {
  onOpenFeedbackMessageOverlay: (feedbackType: FeedbackType) => void
  onClose: () => void
}

export const FeedbackActionsOverlay = React.memo(
  (model: FeedbackActionsOverlayModel) => (
    <FeedbackActionsOverlayView
      {...useFeedbackActionsOverlayViewModel(model)}
    />
  )
)
